/**
 * Carousel: use slick library
 * https://www.npmjs.com/package/slick-carousel
 */

(function($) {
  "use strict";

  $(window).ready(init);

  // Constants
  var CONTAINER_SEL = "[data-slick]";

  /**
   * Init
   */
  function init() {
    var container = $(CONTAINER_SEL);
    if (container.length === 0) {
      return;
    }

    container.not('.slick-initialized').slick();
  }
})(jQuery);
